import { useCore } from '../core/index.js'
import { isLocalhost } from '@booksy-com/vue-tools'

let envWebToolsUrl = null

export const initWebTools = (env) => {
  if (env.VUE_APP_WEB_TOOLS_URL) {
    // shortcut: force web tools url from env.
    envWebToolsUrl = env.VUE_APP_WEB_TOOLS_URL.replace(/\/+$/, '')
  }

  return null
}

const getWebToolsUrl = () => {
  const { store } = useCore()
  if (envWebToolsUrl) {
    return envWebToolsUrl
  }
  return store.getters['routingConfig/webToolsUrl']
}

const getRichTextInputJsUrl = () => {
  const webToolsUrl = getWebToolsUrl()
  if (isLocalhost(webToolsUrl)) {
    return webToolsUrl + '/src/views/rich-text-editor/index.ts'
  }
  return webToolsUrl + '/rich-text-editor/index.umd.js'
}

const getRichTextInputCssUrl = () => {
  const webToolsUrl = getWebToolsUrl()
  if (isLocalhost(webToolsUrl)) {
    return ''
  }
  return webToolsUrl + '/rich-text-editor/style.css'
}

const getRichTextInputIframeUrl = () => {
  const { store } = useCore()
  const webToolsUrl = getWebToolsUrl()
  return webToolsUrl + `/${store.state.app.language}-${store.state.app.country}/rich-text-editor`
}

const getEffortlessKycIframeUrl = (businessId = '', code = '', returnUrl = '') => {
  const { store } = useCore()
  const webToolsUrl = getWebToolsUrl()
  return webToolsUrl + `/${store.state.app.language}-${store.state.app.country}/${businessId}/consents/${code}?return_url=${returnUrl}`
}

export const useWebTools = () => {
  return {
    getWebToolsUrl,
    getRichTextInputJsUrl,
    getRichTextInputCssUrl,
    getRichTextInputIframeUrl,
    getEffortlessKycIframeUrl,
  }
}
